import type { IBarSeriesOption, ILineSeriesOption, IEChartOption } from '@/pages/intelligence/types/echart';

// echart图（所有部分）距离容器的top值，由于echart内部渲染，top值设为20的话，顶部会有部分被遮挡，所以设置30 模拟20的效果
export const ECHART_TOP = 30;
// echart图（所有）距离容器底部的距离
export const ECHART_BOTTOM = 20;
// echart grid的高度，即图表主体内容的高度（不包含图例等其他辅助工具部分，只有柱状图、折线图、饼图主体部分）
export const ECHART_GRID_HEIGHT = 300;
// echart图例高度
export const ECHART_LEGEND_HEIGHT = 16;
// echart图例 每一行的间隔距离
// export const ECHART_LEGEND_LINE_SPACING = 10;
export const ECHART_LEGEND_LINE_SPACING = 4; // 4px，但是由于echarts内部渲染的原因，视觉上就是10px了，如果设置10px，视觉上反而会更大
// echart图例 第一行距离echart图主体部分的间隔距离
// export const ECHART_LEGEND_FIRST_LINE_TOP_SPACING = 16;
export const ECHART_LEGEND_FIRST_LINE_TOP_SPACING = 4; // 4px，但是由于echarts内部渲染的原因，视觉上就是16px了，如果设置16px，视觉上反而会更大
// echart图例 左右两边的留白，即左右两边距离容器的边距
export const ECHART_LEGEND_HORIZONTAL_BOUNDARY_WIDTH = 40;
// echart图例 一行图例时，图例的top
export const ECHART_LEGEND_TOP = ECHART_TOP + ECHART_GRID_HEIGHT + ECHART_LEGEND_FIRST_LINE_TOP_SPACING;
// echart图容器默认高度，按照一行图例计算
export const ECHART_NODE_HEIGHT =
  ECHART_TOP + ECHART_GRID_HEIGHT + ECHART_LEGEND_FIRST_LINE_TOP_SPACING + ECHART_LEGEND_HEIGHT + ECHART_BOTTOM;

// 所有echarts图表的颜色配置
export const ECHART_COLORS = [
  ['#2648A6', '#307DA6', '#358561', '#A8831D', '#A65B29', '#A64453'],
  ['#5086F3', '#5EC8F1', '#69D19C', '#F5D242', '#F19E55', '#F17C86'],
  ['#A6C9FF', '#B5EFFF', '#C0EBD2', '#FFF196', '#FFD8AB', '#FFCCCC'],
  ['#CFE4FF', '#DEF9FF', '#DEF2E4', '#FFF9BF', '#FFECD4', '#FFE6E6'],
];

export const FLATTEN_ECHART_COLORS = ECHART_COLORS.reduce((current, next) => [...current, ...next], []);

// 柱状图基础配置
export const BASE_BAR_SERIES_OPTION: IBarSeriesOption = {
  type: 'bar',
  barMaxWidth: 58,
  tooltip: {
    backgroundColor: 'rgba(0,0,0,0)',
  },
};

// 折线图基础配置
export const BASE_LINE_SERIES_OPTION: ILineSeriesOption = {
  type: 'line',
  showSymbol: false,
  symbol: 'emptyCircle',
  tooltip: {
    backgroundColor: 'rgba(0,0,0,0)',
  },
};

// 贴画基础配置
export const PRIMARY_DECAL_OPTIONS = {
  symbol: 'rect',
  color: 'rgba(255, 255, 255, 1)',
  dashArrayX: [4, 16],
  dashArrayY: [1, 0],
  rotation: 45,
  tooltip: {
    backgroundColor: 'rgba(0,0,0,0)',
  },
};

// echarts公共基础配置
export const BASE_ECHART_OPTION: IEChartOption = {
  color: FLATTEN_ECHART_COLORS,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'line',
    },
    confine: true,
    formatter: () => '',
    backgroundColor: 'rgba(0,0,0,0)',
  },
  grid: {
    // top: 20,
    // right: 0,
    // bottom: 30,
    // left: 0,
    containLabel: true,
    top: ECHART_TOP,
    right: 20,
    left: 20,
    height: ECHART_GRID_HEIGHT,
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    axisLine: {
      show: true,
      lineStyle: {
        // type: 'solid',
        // width: 1,
        color: '#BFBFBF',
      },
    },
    axisLabel: {
      show: true,
      fontSize: 12,
      fontWeight: 400,
      color: '#838697',
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
    },
    axisPointer: {
      lineStyle: {
        type: 'solid',
      },
    },
    data: [],
  },
  yAxis: [
    {
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: true,
        fontSize: 12,
        fontWeight: 400,
        color: '#838697',
      },
      splitLine: {
        show: true,
        // 分割线设置
        lineStyle: {
          type: 'dashed',
          color: '#E9E9E9',
        },
      },
    },
  ],
  legend: {
    show: true,
    type: 'scroll',
    bottom: 10,
    width: '100%',
    icon: 'circle', // 修改icon形状
    itemGap: 20, // 修改每个图例的间距
    itemWidth: 8, // 修改icon图形大小
    itemHeight: 8,
    itemStyle: {
      borderWidth: 0, // icon圆点的边框线宽度
    },
    inactiveBorderWidth: 0, // 图例关闭时icon圆点的描边粗细
    textStyle: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 20,
      color: '#838697',
    },
    pageIconColor: '#838697',
    pageIconInactiveColor: '#EBECF1',
  },
  series: [],
  dataset: {
    dimensions: [],
    source: [],
  },
};
